import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlService } from './url.service';
import {
    EmissionFactorDatabaseDto,
    EmissionFactorHierarchyDto,
} from 'app/@types/dto/emission-factor-hierarchical-structure-dto.model';
import { EmissionFactorDto } from 'app/@types/dto/emission-factor-dto.model';

@Injectable({
    providedIn: 'root',
})
export class EmissionFactorHttpService {
    constructor(
        private http: HttpClient,
        private urlService: UrlService,
    ) {}

    getEmissionFactor(
        organizationId: string,
        dimension: string,
        locale: string,
    ): Observable<EmissionFactorHierarchyDto> {
        return this.http.get<EmissionFactorHierarchyDto>(
            this.urlService.getEmissionFactor(organizationId, dimension, locale),
        );
    }

    getEmissionFactorDatabasesByOrganization(organizationId?: string): Observable<EmissionFactorDatabaseDto[]> {
        return this.http.get<EmissionFactorDatabaseDto[]>(this.urlService.getEmissionFactorDatabaseUrl(organizationId));
    }

    getEmissionFactorByDatabaseId(
        databaseId: string,
        locale: string,
        organizationId?: string,
    ): Observable<EmissionFactorDatabaseDto> {
        return this.http.get<EmissionFactorDatabaseDto>(
            this.urlService.getEmissionFactorByDatabaseId(databaseId, locale, organizationId),
        );
    }

    createEmissionFactorDatabase(organizationId: string, database: EmissionFactorDatabaseDto): Observable<string> {
        return this.http.post<string>(this.urlService.getEmissionFactorDatabaseUrl(organizationId), database);
    }

    updateEmissionFactorDatabase(organizationId: string, database: EmissionFactorDatabaseDto): Observable<void> {
        return this.http.put<void>(this.urlService.getEmissionFactorDatabaseUrl(organizationId), database);
    }

    deleteEmissionFactorDatabase(organizationId: string, databaseId: string): Observable<void> {
        return this.http.delete<void>(this.urlService.getEmissionFactorDatabaseDeleteUrl(organizationId, databaseId));
    }

    createDimension(
        dimension: EmissionFactorHierarchyDto,
        locale: string,
        organizationId?: string,
    ): Observable<EmissionFactorDatabaseDto> {
        return this.http.post<EmissionFactorDatabaseDto>(
            this.urlService.dimensionHierarchyUrl(organizationId, locale),
            dimension,
        );
    }

    deleteDimension(
        dimensionId: string,
        databaseId: string,
        locale: string,
        organizationId?: string,
    ): Observable<EmissionFactorDatabaseDto> {
        return this.http.delete<EmissionFactorDatabaseDto>(
            this.urlService.deleteDimensionUrl(dimensionId, databaseId, locale, organizationId),
        );
    }

    updateDimension(
        dimension: EmissionFactorHierarchyDto,
        locale: string,
        organizationId?: string,
    ): Observable<EmissionFactorDatabaseDto> {
        return this.http.put<EmissionFactorDatabaseDto>(
            this.urlService.dimensionHierarchyUrl(organizationId, locale),
            dimension,
        );
    }

    createEmissionFactor(
        emissionFactor: EmissionFactorDto,
        locale: string,
        organizationId?: string,
    ): Observable<EmissionFactorDatabaseDto> {
        return this.http.post<EmissionFactorDatabaseDto>(
            this.urlService.createEmissionFactorUrl(locale, organizationId),
            emissionFactor,
        );
    }

    updateEmissionFactor(
        emissionFactor: EmissionFactorDto,
        locale: string,
        organizationId?: string,
    ): Observable<EmissionFactorDatabaseDto> {
        return this.http.put<EmissionFactorDatabaseDto>(
            this.urlService.createEmissionFactorUrl(locale, organizationId),
            emissionFactor,
        );
    }

    deleteEmissionFactor(
        emissionFactorId: string,
        databaseId: string,
        locale: string,
        organizationId?: string,
    ): Observable<EmissionFactorDatabaseDto> {
        return this.http.delete<EmissionFactorDatabaseDto>(
            this.urlService.deleteEmissionFactorUrl(databaseId, emissionFactorId, locale, organizationId),
        );
    }
}
